import React from 'react'
import styled from '@emotion/styled'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import MessageBar from './MessageBar'

const MessageStack = () => {
  const { messages, removeMessage } = useMessageStore()

  const typePriority = { error: 0, message: 1, cta: 2 } as const
  const sorted = [...messages]
    .reverse()
    .sort((a, b) => typePriority[a.type] - typePriority[b.type])

  return (
    <Stack messages={messages.length}>
      {sorted.map((msg) => (
        <MessageBar key={msg.id} msg={msg} onDismiss={removeMessage} />
      ))}
    </Stack>
  )
}

const Stack = styled.div<{ messages: number }>(
  ({ messages }) => `
  padding: 0 24px;
  margin: ${messages > 0 ? '24px' : '0'} 24px 0 24px;
  transition: margin-top 200ms ease;

  display: flex;
  flex-direction: column;
`
)

export default MessageStack
